module.exports = __webpack_public_path__ + "img/redwulf-70A.c6eb3ef4.png";